import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _03_CROPS:Partial<EcosystemServiceModel> ={
  id:'crops',
  pos:3,
  image: "/images/ecoservices/crops.jpg",
  code: ["1.1.1.1"],
  unit:'crops',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "crops",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
